export default __webpack_public_path__ + "static/media/abstracto2768.2ea6d3b5.jpg";